import { render, staticRenderFns } from "./BcReport.vue?vue&type=template&id=47983628&scoped=true"
import script from "./BcReport.vue?vue&type=script&lang=js"
export * from "./BcReport.vue?vue&type=script&lang=js"
import style0 from "./BcReport.vue?vue&type=style&index=0&id=47983628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47983628",
  null
  
)

export default component.exports